var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaMatAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1149 20H16.2149C18.0309 20 19.8063 19.4625 21.3173 18.4551C21.7438 18.1708 22 17.6921 22 17.1795V6.82816C22 6.04672 21.1291 5.58062 20.4789 6.01408C19.5146 6.65696 18.3816 7.00001 17.2226 7.00001H11.4999V17C11.4999 18.2201 10.9253 19.2539 10.1149 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 5.34315 8.20914 4 6 4C3.79086 4 2 5.34315 2 7V17C2 18.6569 3.79086 20 6 20C8.20914 20 10 18.6569 10 17V7ZM6 19C4.34315 19 3 18.1046 3 17C3 15.8954 4.34315 15 6 15C7.65685 15 9 15.8954 9 17C9 18.1046 7.65685 19 6 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaMatAlt);
export default __webpack_public_path__ + "static/media/yoga-mat-alt.818258c44a981094009100630bc9eb97.svg";
export { ForwardRef as ReactComponent };